/* eslint-disable */
import { createSelector } from 'reselect';
import { storeActive as storeActiveSelector } from 'ggApp/modules/store/selectors';
import { MODULE_NAME, SHIPPING_NAME, BILLING_NAME } from '../constants';

function addressArray(address, addressType) {
    if (address) {
        return addressType !== BILLING_NAME ? [
            `${address.address1} ${address.address2}, ${address.zipcode}`,
            `${address.city}, ${address.country_name}`,
        ] : [
            'NAVIGATOR_BILLING_ADDRESS_TITLE',
            `${address.address1} ${address.address2}, ${address.zipcode}`,
            `${address.city}, ${address.country_name}`,
        ];
    }
    return [];
}

export const moduleState = state => state[MODULE_NAME];

export const addressList = createSelector(
    moduleState,
    m => m.list.data,
);

export const addressListForCurrentCountry = createSelector(
    addressList,
    storeActiveSelector,
    (addresses, store) => addresses.filter(a => a.country_id === store.country_id),
);

export const addressListFetching = createSelector(
    moduleState,
    m => m.list.fetching,
);

export const activeAddressShippingId = createSelector(
    moduleState,
    m => m.active[SHIPPING_NAME.toLowerCase()],
);
export const activeAddressBillingId = createSelector(
    moduleState,
    m => m.active[BILLING_NAME.toLowerCase()],
);

export const activeAddressShipping = createSelector(
    addressList,
    activeAddressShippingId,
    (al, s) => al.find(a => a.id === s),
);
export const activeAddressBilling = createSelector(
    addressList,
    activeAddressBillingId,
    (al, b) => al.find(a => a.id === b),
);

export const activeAddressShippingNavi = createSelector(
    activeAddressShipping,
    addressArray,
);
export const activeAddressBillingNavi = createSelector(
    activeAddressBilling,
    address => addressArray(address, BILLING_NAME),
);
